export default "__VITE_ASSET__IlL2QEby__"